import React from 'react'
import ImageComponent from '../../UI/Image/ImageComponent'
import styles from './styles.module.scss'
import Button from '../../UI/Button/Button'
import defaultImg from '../../../src/assets/images/seafarer-search.png'
import PropTypes from 'prop-types'

export default function NotFoundResult({
  text = 'Sorry, there are no results for this search',
  buttonText = null,
  buttonClick,
  img,
}) {
  const imageSrc = img || defaultImg

  // Разделяем текст по точкам и добавляем <br />
  const formattedText = text.split('.').map((part, index) => (
    <React.Fragment key={index}>
      {part.trim()}
      {index < text.split('.').length - 1 && <br />}
    </React.Fragment>
  ))

  return (
    <article className={styles['not-found-result']}>
      <div className={styles['not-found-result__wrapper']}>
        <ImageComponent src={imageSrc} alt='not-found-result' className={styles['not-found-result__img']} />
        <p className={styles['not-found-result__text']}>{formattedText}</p>
        {buttonText && (
          <div className={styles['not-found-result__button-wrapper']}>
            <Button className={styles.deleteApplication} size='middle-full' onClick={buttonClick} disabled={false}>
              {buttonText}
            </Button>
          </div>
        )}
      </div>
    </article>
  )
}

NotFoundResult.propTypes = {
  text: PropTypes.string,
  buttonText: PropTypes.string,
  buttonClick: PropTypes.func,
  img: PropTypes.string,
}
